import axios from 'axios';
import {BACKEND_BASEURL} from "@/config/config";

/**
 * Admin-only energy data cleanup (backend /energyDataAdmin). Stage 1 is the
 * JSON export of the raw consumption day documents — the backup that has to
 * exist before anything gets removed.
 */
export async function fetchConsumptionDataExport(ecn, ecid, meteringPoint, dateFrom, dateTo) {
  const response = await axios.get(
    `${BACKEND_BASEURL}energyDataAdmin/${ecn}/${ecid}/consumptionData/${meteringPoint}`
    + `/from/${dateFrom}/to/${dateTo}`,
  );
  return response.data;
}

/**
 * Removes the exported documents. expectedCount is the count from the JSON
 * export — the backend aborts when the data changed in between.
 */
export async function deleteConsumptionData(ecn, ecid, meteringPoint, dateFrom, dateTo, expectedCount) {
  const response = await axios.delete(
    `${BACKEND_BASEURL}energyDataAdmin/${ecn}/${ecid}/consumptionData/${meteringPoint}`
    + `/from/${dateFrom}/to/${dateTo}`,
    {data: {expectedCount}},
  );
  return response.data;
}
